import { useState, useEffect } from "react";
import { post } from "../services/services";
import { ApiURL } from "../services/apiConstants";

const useVoyageList = () => {
  const [voyageList, setVoyageList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [runningState, setRunningState] = useState(null);

  const fetchVoyageList = async () => {
    setLoading(true);
    setError(null);
    try {
      const FORM_DATA = new FormData();
      const response = await post(ApiURL.list_voyage_info, FORM_DATA);
      if (response?.status) {
        const voyages = response?.voyage || [];
        setVoyageList(voyages);
        setRunningState(voyages[0]?.voyage_status || null);
      } else {
        setError("Failed to fetch voyage list");
      }
    } catch (err) {
      console.error("Error fetching Voyage list:", err);
      setError("An error occurred while fetching voyages.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVoyageList();
  }, []);

  return { voyageList, loading, error, runningState, fetchVoyageList };
};

export default useVoyageList;
